import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

export default styled(Button).attrs({ eventActionResult: 'next_step' })``;
